module.exports = __webpack_public_path__ + "static/media/education.ea271188.png";